module.exports = __webpack_public_path__ + "7b30abe760f8a68aa0a81a4c7c04bb38.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-medium.woff
// module id = 75
// module chunks = 0